/**
 * Builders puros de paths/query da api-conciliacao (testáveis sem axios).
 */

export function buildBuscarConciliacoesPath(idEmpresa, idExtrato, params) {
  const search = new URLSearchParams();
  if (params?.tipoContabil) {
    search.set("tipoContabil", params.tipoContabil);
  }
  if (params?.pagina !== undefined) {
    search.set("pagina", String(params.pagina));
  }
  if (params?.tamanhoPagina !== undefined) {
    search.set("tamanhoPagina", String(params.tamanhoPagina));
  }
  if (params?.filtroIgnorado && params.filtroIgnorado !== "todos") {
    search.set("filtroIgnorado", params.filtroIgnorado);
  }
  if (params?.descricao?.trim()) {
    search.set("descricao", params.descricao.trim());
  }
  if (params?.quantiaBusca?.trim()) {
    search.set("quantiaBusca", params.quantiaBusca.trim());
  }
  if (params?.contaDebito?.trim()) {
    search.set("contaDebito", params.contaDebito.trim());
  }
  if (params?.descricaoDebito?.trim()) {
    search.set("descricaoDebito", params.descricaoDebito.trim());
  }
  if (params?.contaCredito?.trim()) {
    search.set("contaCredito", params.contaCredito.trim());
  }
  if (params?.descricaoCredito?.trim()) {
    search.set("descricaoCredito", params.descricaoCredito.trim());
  }
  if (params?.dtInicio?.trim()) {
    search.set("dtInicio", params.dtInicio.trim());
  }
  if (params?.dtFim?.trim()) {
    search.set("dtFim", params.dtFim.trim());
  }
  const qs = search.toString();
  return `/extratos/${idEmpresa}/conciliacao/${idExtrato}${qs ? `?${qs}` : ""}`;
}

export function buildFiltrarIntervaloPath(idEmpresa, idExtrato) {
  return `/extratos/${idEmpresa}/conciliacao/${idExtrato}/filtrar-intervalo`;
}

export function buildFiltrarExtratosPorTextoPath(idEmpresa, textoDeBusca) {
  return `/extratos/${idEmpresa}/filtrar-extratos?textoDeBusca=${encodeURIComponent(
    textoDeBusca ?? ""
  )}`;
}
